import { render, staticRenderFns } from "./caseReview.vue?vue&type=template&id=431f6be9"
import script from "./caseReview.vue?vue&type=script&lang=js"
export * from "./caseReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports